<template>
  <div
    class="delivery-page"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <template v-if="!homeLoading && docData.outsourcingtowarehouseId">
      <finishAdd
        v-if="docData.statusCheck == 0"
        :key="'edit-' + docData.outsourcingtowarehouseId"
        :itemList="detailList"
        :finish_type="1"
        @backOrderState="getList"
        @backHome="backHome"
      />

      <template v-else>
        <div class="page-header">
          <div class="page-header__left">
            <h2 class="page-header__title">委外出货单详情</h2>
          </div>
          <div class="page-header__actions">
            <el-button size="small" plain @click="backHome">返回</el-button>
            <el-button
              v-if="showOutWarehouseButton"
              size="small"
              type="primary"
              :loading="outWarehouseLoading"
              @click="handleOutWarehouse"
            >出库</el-button>
            <el-button
              v-if="showCancelOutWarehouseButton"
              size="small"
              type="info"
              :loading="cancelOutWarehouseLoading"
              @click="handleCancelOutWarehouse"
            >撤销出库</el-button>
            <el-button
              v-if="showCancelAuditButton"
              size="small"
              type="info"
              :loading="cancelAuditLoading"
              @click="handleCancelAudit"
            >取消审核</el-button>
            
          </div>
        </div>

        <div class="delivery-card">
          <div class="delivery-card__head">
            <div class="delivery-card__head-left">
              <span class="delivery-card__label">出货单</span>
              <span class="delivery-card__title">{{
                docData.outsourcingtowarehouseNumber || "委外出货单"
              }}</span>
            </div>
          </div>

          <div class="info-grid">
            <div class="info-item">
              <label>委外订单号</label>
              <span>{{ docData.baseOutsourcingDocNumber || "--" }}</span>
            </div>
            <div class="info-item">
              <label>出货单号</label>
              <span>{{ docData.outsourcingtowarehouseNumber || "--" }}</span>
            </div>
            <div class="info-item">
              <label>预计到货日期</label>
              <span>{{ displayExpectedDate }}</span>
            </div>
            <div class="info-item">
              <label>物流公司</label>
              <span>{{ docData.baseLogisticsCompany || "--" }}</span>
            </div>
            <div class="info-item">
              <label>物流单号</label>
              <span>{{ docData.baseLogisticsNumber || "--" }}</span>
            </div>
            <div class="info-item">
              <label>联系方式</label>
              <span>{{ docData.baseLogisticsContact || docData.baseContactPhone || docData.baseContactInfo || "--" }}</span>
            </div>
            <div class="info-item info-item--full">
              <label>备注</label>
              <span>{{ docData.remark || "--" }}</span>
            </div>
          </div>
        </div>

        <div class="delivery-card delivery-card--detail">
          <div class="delivery-card__head delivery-card__head--plain">
            <span class="delivery-card__title">出货明细</span>
          </div>

          <el-table
            v-if="detailList.length"
            :data="detailList"
            border
            size="small"
            class="detail-table"
          >
            <el-table-column
              type="index"
              label="序号"
              width="55"
              align="center"
            />
            <el-table-column label="产品编号" min-width="120" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.baseMaterialNumber || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="产品名称" min-width="140" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.baseMaterialName || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="规格" min-width="140" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ formatSpecLabel(row) }}
              </template>
            </el-table-column>
            <el-table-column label="批次号" min-width="120" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.batchNumber || "--" }}
              </template>
            </el-table-column>
            <el-table-column label="可发数量" min-width="100" align="left">
              <template slot-scope="{ row }">
                {{ formatQty(row.valueUnfinishedQuantity) }}
              </template>
            </el-table-column>
            <el-table-column label="本次出货" min-width="120" align="left">
              <template slot-scope="{ row }">
                {{ formatQty(row.baseOutsourcingFinishedQuantity) }}
              </template>
            </el-table-column>
            <el-table-column label="良品数量" min-width="100" align="left">
              <template slot-scope="{ row }">
                {{ formatQty(row.valueQualifiedQuantity) }}
              </template>
            </el-table-column>
            <el-table-column label="损耗数量" min-width="100" align="left">
              <template slot-scope="{ row }">
                {{ formatQty(row.valueUnqualifiedQuantity) }}
              </template>
            </el-table-column>
            <el-table-column label="单位" min-width="70" align="left">
              <template slot-scope="{ row }">
                {{ row.baseMaterialUnitName || "--" }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="docData.statusCheck == 1" class="checkImg">
          <img src="@/assets/images/examine.png" alt="已审核" />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import {
  outsourcingtowarehouse_view,
  outsourcingtowarehouse_auditByGlobal,
  outsourcingtowarehouse_outWarehouse,
  outsourcingtowarehouse_cancellationOutWarehouse
} from '@/api/myController/outsourcing';
import finishAdd from '@/views/outsourcingProduct/components/finish_add.vue';
import {
  formatProductLabel,
  formatSpecLabel,
  formatQty,
  normalizeDetailRow,
  getCooperativeStatusLabel,
  applyHeaderFields,
  createDefaultForm,
  buildAuditPayload,
  buildOutWarehouseActionPayload,
  resolveAuditGlobalId
} from '@/utils/outsourcingFinishDelivery';
export default {
  props: {
    routeType: {
      type: Array,
      default: undefined
    },
    routeQuery: {
      default: () => ({})
    }
  },
  components: { finishAdd },
  data() {
    return {
      homeLoading: false,
      cancelAuditLoading: false,
      outWarehouseLoading: false,
      cancelOutWarehouseLoading: false,
      docData: {},
      outsourcingtowarehouse_view,
      detailList: []
    };
  },
  computed: {
    showCancelAuditButton() {
      return Number(this.docData.statusCheck) === 1;
    },
    showOutWarehouseButton() {
      return Number(this.docData.statusOutwarehouse) === 0;
    },
    showCancelOutWarehouseButton() {
      return Number(this.docData.statusOutwarehouse) === 1;
    },
    statusLabel() {
      return getCooperativeStatusLabel(this.docData.statusCooperativeDoc);
    },
    displayExpectedDate() {
      return (
        this.docData.baseExpectedArrivalDate ? this.docData.baseExpectedArrivalDate.split(' ')[0] : '' ||
        this.docData.baseInwarehouseTime ? this.docData.baseInwarehouseTime.split(' ')[0] : '' ||
        '--'
      );
    }
  },
  created() {
    this.getList();
  },
  methods: {
    formatProductLabel,
    formatSpecLabel,
    formatQty,
    normalizeDetail(data) {
      const form = applyHeaderFields(createDefaultForm(), data);
      return normalizeDetailRow({
        ...data,
        baseOutsourcingDocId: form.baseOutsourcingDocId,
        baseOutsourcingDocNumber: form.baseOutsourcingDocNumber
      });
    },
    getList() {
      this.homeLoading = true;
      outsourcingtowarehouse_view({
        outsourcingtowarehouseId: this.routeQuery.outsourcingtowarehouseId
      })
        .then((res) => {
          const raw = res.data.data || {};
          this.docData = applyHeaderFields(createDefaultForm(), raw);
          this.detailList = [this.normalizeDetail(raw)];
        })
        .finally(() => {
          this.homeLoading = false;
        });
    },
    backHome() {
      this.$emit('backHome');
    },
    handleCancelAudit() {
      const globalId = resolveAuditGlobalId(this.docData);
      if (!globalId) {
        this.$message.error('缺少单据 globalId');
        return;
      }
      this.$confirm('确认取消审核该出货单？', '提示', {
        type: 'warning'
      })
        .then(async () => {
          this.cancelAuditLoading = true;
          try {
            await outsourcingtowarehouse_auditByGlobal(
              buildAuditPayload(globalId, 2)
            );
            this.$message.success('已取消审核');
            this.getList();
          } finally {
            this.cancelAuditLoading = false;
          }
        })
        .catch(() => {});
    },
    handleOutWarehouse() {
      const docId = this.docData.outsourcingtowarehouseId;
      if (!docId) {
        this.$message.error('缺少出货单 ID');
        return;
      }
      this.$confirm('确认对该出货单执行出库？', '提示', {
        type: 'warning'
      })
        .then(async () => {
          this.outWarehouseLoading = true;
          try {
            await outsourcingtowarehouse_outWarehouse(
              buildOutWarehouseActionPayload(docId)
            );
            this.$message.success('出库成功');
            this.getList();
          } finally {
            this.outWarehouseLoading = false;
          }
        })
        .catch(() => {});
    },
    handleCancelOutWarehouse() {
      const docId = this.docData.outsourcingtowarehouseId;
      if (!docId) {
        this.$message.error('缺少出货单 ID');
        return;
      }
      this.$confirm('确认撤销该出货单的出库？', '提示', {
        type: 'warning'
      })
        .then(async () => {
          this.cancelOutWarehouseLoading = true;
          try {
            await outsourcingtowarehouse_cancellationOutWarehouse(
              buildOutWarehouseActionPayload(docId)
            );
            this.$message.success('已撤销出库');
            this.getList();
          } finally {
            this.cancelOutWarehouseLoading = false;
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss">
.delivery-page {
  position: relative;
  min-height: calc(100vh - 130px);
  background: #fff;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}

.page-header__title {
  margin: 0 0 6px;
  font-size: 22px;
  line-height: 1.3;
  color: #1476c3;
  font-weight: 600;
}

.page-header__desc {
  margin: 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}

.page-header__actions {
  display: flex;
  flex-wrap: wrap;
  padding-top: 4px;
}

.delivery-card {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.delivery-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 12px 20px;
  background: linear-gradient(90deg, #eef6ff 0%, #f9fcff 100%);
  border-bottom: 1px solid #e4e7ed;
}

.delivery-card__head--plain {
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.delivery-card__head-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.delivery-card__label {
  color: #606266;
  font-size: 14px;
}

.delivery-card__title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
}

.status-tag {
  display: inline-block;
  padding: 3px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 4px;
  white-space: nowrap;
}

.status-tag--success {
  color: #67c23a;
  background: #f0f9eb;
  border: 1px solid #c2e7b0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px 24px;
  padding: 20px 20px 22px;
}

.info-item {
  label {
    display: block;
    margin-bottom: 6px;
    color: #606266;
    font-size: 13px;
  }

  span {
    display: block;
    min-height: 34px;
    line-height: 34px;
    padding: 0 12px;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    color: #303133;
    font-size: 13px;
    word-break: break-all;
  }
}

.info-item--full {
  grid-column: 1 / -1;

  span {
    min-height: 68px;
    line-height: 1.6;
    padding: 8px 12px;
  }
}

.delivery-card--detail {
  padding-bottom: 16px;
}

.detail-table {
  margin: 16px 20px 0;
  width: calc(100% - 40px);
}

::v-deep .detail-table {
  .el-table__header th {
    background: #fafbfc;
    color: #606266;
    font-weight: 500;
  }

  .el-table__body td {
    vertical-align: middle;
  }
}

.checkImg {
  position: absolute;
  right: 48px;
  top: 58px;
  width: 130px;
  height: 130px;
  z-index: 2;
  pointer-events: none;
  opacity: 0.9;
  transform: rotate(15deg);
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
